// ─── TEXT PROCESSING UTILITIES ───────────────────────────────────────────────
// Pure functions — no state, no React, no side effects.

// ─── URL Validator ───────────────────────────────────────────────────────────

export function isValidUrl(url) {
  if (!url) return false;
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch (_e) {
    return false;
  }
}

// ─── URL Normalizer ─────────────────────────────────────────────────────────

export function normalizeUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return 'https://' + trimmed;
}

// ─── HTML Sanitizer ──────────────────────────────────────────────────────────

export function sanitizeHtml(html) {
  if (!html) return '';
  // eslint-disable-next-line no-useless-concat
  const openCite  = new RegExp('<' + 'antml:cite' + '[^>]*>', 'gi');
  // eslint-disable-next-line no-useless-concat
  const closeCite = new RegExp('</' + 'antml:cite' + '>', 'gi');
  return html
    .replace(openCite, '<em>').replace(closeCite, '</em>')
    .replace(/<cite\s+index="[^"]*">/gi, '<em>').replace(/<\/cite>/gi, '</em>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<script\b[^>]*\/?>/gi, '')
    .replace(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|`[^`]*`|[^\s>]+)/gi, '')
    .replace(/(?:href|src|action|formaction)\s*=\s*(?:"[\s]*javascript:[^"]*"|'[\s]*javascript:[^']*'|[\s]*javascript:[^\s>]+)/gi, 'href="#"')
    .replace(/src\s*=\s*(?:"data:(?:text\/html|application)[^"]*"|'data:(?:text\/html|application)[^']*')/gi, 'src=""')
    .replace(/(?:href|src)\s*=\s*(?:"[\s]*vbscript:[^"]*"|'[\s]*vbscript:[^']*')/gi, 'href="#"')
    .replace(/<(iframe|object|embed|form|base|meta|link)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
    .replace(/<(iframe|object|embed|form|base|meta|link)\b[^>]*\/?>/gi, '')
    .replace(/style\s*=\s*(?:"[^"]*(?:expression|javascript)[^"]*"|'[^']*(?:expression|javascript)[^']*')/gi, '');
}

